// Shared color palette for charts across the application
export const CHART_COLORS = [
  '#087443', // Dark Green
  '#64AC72', // Light Green
  '#FFEE8C', // Yellow
  '#FAB661', // Orange
  '#D6DF81', // Lime
  '#8B5CF6', // Purple
  '#EF4444', // Red
  '#06B6D4', // Cyan
  '#84CC16', // Lime Green
  '#F59E0B', // Amber
] as const

// Type for accessing chart colors
export type ChartColor = (typeof CHART_COLORS)[number]

// Helper function to get color by index with cycling
export function getChartColor(index: number): string {
  return CHART_COLORS[index % CHART_COLORS.length]
}
